export default __webpack_public_path__ + "static/media/PEPE.9dab3938.png";